import { render, staticRenderFns } from "./casedescDialog.vue?vue&type=template&id=5602c794&scoped=true"
import script from "./casedescDialog.vue?vue&type=script&lang=js"
export * from "./casedescDialog.vue?vue&type=script&lang=js"
import style0 from "./casedescDialog.vue?vue&type=style&index=0&id=5602c794&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5602c794",
  null
  
)

export default component.exports